const googleKeys = {
    PRO_ReCAPTCHA_KEY: "6LcZX60UAAAAAMQsf25I7hmQ-FI6m9LjoOh0e5m3",
    TEST_ReCAPTCHA_KEY: "6LctiaAUAAAAAGy9kNANGdk7o7uW9LcT6Rfun87Z"
}


export default googleKeys;